const initGoogleAutocomplete = () => {
  function initializeAutocomplete(id) {
    var element = document.getElementById(id);
    if (element) {
      var autocomplete = new google.maps.places.Autocomplete(element, {
        componentRestrictions: { country: "au" },
      });
      google.maps.event.addListener(
        autocomplete,
        "place_changed",
        onPlaceChanged
      );
    }
  }

  function onPlaceChanged() {
    var place = this.getPlace();

    // console.log(place);  // Uncomment this line to view the full object returned by Google API.

    for (var i in place.address_components) {
      var component = place.address_components[i];
      for (var j in component.types) {
        // Some types are ["country", "political"]
        var type_element = document.getElementById(component.types[j]);
        if (type_element) {
          type_element.value = component.long_name;
        }
      }
    }

    // const [ latitude, longitude ] = [ place.geometry.location.lat(), place.geometry.location.lng() ];

    // if (latitude && longitude) {
    //   const lat_element = document.getElementById('vehicle-latitude');
    //   const lng_element = document.getElementById('vehicle-longitude');

    //   if (lat_element && lng_element) [ lat_element.value, lng_element.value ] = [ latitude, longitude ]
    // }
  }
  google.maps.event.addDomListener(window, "load", function () {
    initializeAutocomplete("vehicle-address");
    initializeAutocomplete("business-address");
  });
}

export { initGoogleAutocomplete };
